import Loadable from 'UIComponents/decorators/Loadable';
const AsyncPricingBreakdownModal = Loadable({
  loader: () => import( /* webpackChunkName: "pricing-breakdown-modal" */'./PricingBreakdownModal'),
  LoadingComponent: () => null
});
export default AsyncPricingBreakdownModal;